import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import { submitOnchangeForm } from '../handler/HelpdeskCreateTicketHandler';
import { submitOnchangeFormQA } from '../handler/QaTicketHandler';

export const DialogConfirmChangeForm = props => {
    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        if(props.isHelpDesk){
            props.setIsConfirmChangeForm(false);
        }
        if(props.isQA){
            props.setIsOpenDialogQAConfirmChangeFormType(false);
        }
    };

    const onHandlerConfirmChange = () => {
        submitOnchangeForm(props.selectedFormChange, props);
        props.setSelectedFormChange('');
        props.setIsConfirmChangeForm(false);
        props.setIsEdited(true);

        // Reset external customer form data
        props.setExternalCustomerProjectList([]);
        props.setExternalCustomerRequestKeyword('');
        props.setExternalCustomerRequestProject({});
        props.setExternalCustomerProjectErr({
            error: false,
            helperText: ''
        });
        if (props.setSelectedAssigneeUserId) {
            props.setSelectedAssigneeUserId('');
        }
    };

    const onHandlerConfirmChangeQA = () => {
        submitOnchangeFormQA(props.selectedFormChange, props);
        props.setIsOpenDialogQAConfirmChangeFormType(false);
        props.setIsEdited(true);
    };



    return (
        <Dialog
            open={props.isConfirmChangeForm}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    {I18n.get('USER04MSG017')}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="confirm-dialog-button btn-hg32 btn-handle-delete-user-agree"
                    variant="contained"
                    onClick={() => props.isHelpDesk ? onHandlerConfirmChange(props) : onHandlerConfirmChangeQA()}
                >
                    {I18n.get('COMBTN002')}
                </Button>
                <Button
                    className="confirm-dialog-button btn-hg32"
                    variant="contained"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {I18n.get('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
